import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-0d3b9362")

_pushScopeId("data-v-0d3b9362")
const _hoisted_1 = { class: "overlay digest-line" }
const _hoisted_2 = { class: "digest__body" }
const _hoisted_3 = { class: "digest" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "digest__name" }, null, -1)
const _hoisted_5 = { class: "digest__body lines" }
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "lines__body" }, null, -1)
const _hoisted_7 = { class: "lines__text" }
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_openBlock(true), _createBlock(_Fragment, null, _renderList($setup.filtered, (item, itemInd) => {
      return (_openBlock(), _createBlock("div", {
        key: itemInd,
        class: "digest"
      }, [
        _createVNode("div", {
          class: "digest__name",
          title: item.name
        }, _toDisplayString($setup.getName(item)), 9, ["title"]),
        _createVNode("div", _hoisted_2, [
          _createVNode("div", {
            style: {
            backgroundColor: $setup.getColor(item.id),
            width: $setup.percents[itemInd] + '%'
          },
            class: "digest__color"
          }, null, 4)
        ])
      ]))
    }), 128 /* KEYED_FRAGMENT */)),
    _createVNode("div", _hoisted_3, [
      _hoisted_4,
      _createVNode("div", _hoisted_5, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList($setup.getRange, (r) => {
          return (_openBlock(), _createBlock("div", {
            key: r,
            class: "lines__item"
          }, [
            _hoisted_6,
            _createVNode("div", _hoisted_7, _toDisplayString(r), 1)
          ]))
        }), 128 /* KEYED_FRAGMENT */))
      ])
    ])
  ]))
})